// extracted by mini-css-extract-plugin
export default {"text-card-markdown":"dEs6g","cursor-text":"_8TLiW"};